module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-live-with-page",
    class: {
      show: _vm.showPage
    }
  }, [_c('topNav', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bcont"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "info",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('addLiveWith_name')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookInfo.name),
      expression: "bookInfo.name"
    }],
    staticClass: "inp",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('addLiveWith_name_place'),
      "maxlength": "64"
    },
    domProps: {
      "value": (_vm.bookInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookInfo, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.isJingJiang) ? _c('i', {
    staticClass: "iconfont icon-credentials_icon",
    staticStyle: {
      "position": "absolute",
      "right": "0.42rem",
      "color": "#999"
    },
    on: {
      "click": _vm.getJingJiangToken
    }
  }) : [(_vm.sfzR && _vm.hasSfzRight) ? _c('i', {
    staticClass: "iconfont icon-saoma",
    staticStyle: {
      "position": "absolute",
      "right": "0.42rem",
      "color": "#999"
    },
    on: {
      "click": _vm.sfzRe
    }
  }) : _vm._e()]], 2), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('book_mobile')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookInfo.mobile),
      expression: "bookInfo.mobile"
    }],
    staticClass: "inp",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('book_mobile_placeholder'),
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.bookInfo.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookInfo, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('book_idCode')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "idCode"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('book_idNo')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookInfo.idNo),
      expression: "bookInfo.idNo"
    }],
    staticClass: "inp",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('book_idNo_placeholder')
    },
    domProps: {
      "value": (_vm.bookInfo.idNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookInfo, "idNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('sexDesc')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "sex",
    attrs: {
      "placeholder": _vm.$t('memberRegister_sex_placeholder')
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "vip",
    attrs: {
      "placeholder": _vm.$t('memberRegister_sex_placeholder')
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('book_rmno'))), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookInfo.rmno),
      expression: "bookInfo.rmno"
    }],
    staticClass: "inp",
    staticStyle: {
      "color": "#F69C2D"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.bookInfo.rmno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookInfo, "rmno", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.more = !_vm.more
      }
    }
  }, [(!_vm.more) ? _c('div', {
    staticClass: "mdiv"
  }, [_vm._v(_vm._s(_vm.$t('book_more_parmas')) + " "), _c('i', {
    staticClass: "iconfont icon-xiaa"
  })]) : _c('div', {
    staticClass: "mdiv"
  }, [_vm._v(_vm._s(_vm.$t('book_packup_parmas'))), _c('i', {
    staticClass: "iconfont icon-shanga"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }]
  }, [_c('div', {
    staticClass: "info long-label"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('addLiveWith_same_rsvn_no')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('mt-switch', {
    model: {
      value: (_vm.bookInfo.autoRsvNo),
      callback: function($$v) {
        _vm.$set(_vm.bookInfo, "autoRsvNo", $$v)
      },
      expression: "bookInfo.autoRsvNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info long-label"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('addLiveWith_copyPackage')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('mt-switch', {
    model: {
      value: (_vm.bookInfo.autoPackages),
      callback: function($$v) {
        _vm.$set(_vm.bookInfo, "autoPackages", $$v)
      },
      expression: "bookInfo.autoPackages"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info long-label"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('addLiveWith_checkIn')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('mt-switch', {
    model: {
      value: (_vm.bookInfo.autoCheckIn),
      callback: function($$v) {
        _vm.$set(_vm.bookInfo, "autoCheckIn", $$v)
      },
      expression: "bookInfo.autoCheckIn"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('addLiveWith_nation')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "country"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('addLiveWith_language')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "language"
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "foot l_o_btm"
  }, [_c('div', {
    staticClass: "bookbtn",
    on: {
      "click": _vm.book
    }
  }, [_vm._v(_vm._s(_vm.title) + "\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("VIP "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7f1c0d5c","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/fangTXQ/addLiveWith.vue
// module id = 1811
// module chunks = 107